angular
  .module('specsguardApp')
  .filter('sgTrusted', sgTrusted);

sgTrusted.$inject = ['$sce'];

function sgTrusted ($sce: ng.ISCEService): Function {

  /**
   * Convert HTML string to trusted HTML string.
   *
   * @param {string} htmlString Untrusted HTML string.
   * @returns {string} Trusted HTML string.
   */
  return function (htmlString: string | number | null = ' '): string {
    if (!htmlString) {
      htmlString = ' ';
    } else if (typeof htmlString === 'number') {
      htmlString = htmlString.toString();
    }

    return $sce.trustAsHtml(htmlString);
  }
};
